import { LoadingSkeleton } from 'components'
import { TableColumn } from 'components/Table/Table'
import { ConnectionStatus } from 'api/partners/connectionStatus'

import * as Styled from '../styles'

type Props = {
  columns: Array<TableColumn<ConnectionStatus>>
  data: ConnectionStatus[]
  rowKey: string
  isLoading: boolean
}

const ToosTable = ({ columns, data, rowKey, isLoading }: Props) => {
  if (isLoading) {
    return <LoadingSkeleton lineCount={5} />
  }

  return (
    <Styled.PosTable>
      <thead>
        <tr>
          {columns.map((column) => (
            <Styled.PosHeaderCell key={column.key} align={column.headerAlign}>
              {column.title}
            </Styled.PosHeaderCell>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row) => (
          <Styled.PosTableRow key={row[rowKey as keyof ConnectionStatus] as string}>
            {columns.map((column) => (
              <Styled.PosBodyCell key={column.key}>
                {column.render ? column.render(row) : ''}
              </Styled.PosBodyCell>
            ))}
          </Styled.PosTableRow>
        ))}
      </tbody>
    </Styled.PosTable>
  )
}

export default ToosTable 